var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var WishlistFullSvg = /* @__PURE__ */ __name(function WishlistFullSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M22.573 2.062c-2.707 0-5.129 2.569-6.573 4.916-1.449-2.356-3.871-4.929-6.564-4.929-3.72 0-7.484 2.729-7.484 7.947s4.889 10.307 11.111 16.836c0.889 0.942 1.818 1.911 2.756 2.911l0.182 0.209 0.191-0.204c0.938-1 1.858-1.969 2.751-2.911 6.222-6.529 11.111-11.684 11.111-16.836s-3.764-7.938-7.48-7.938z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M16 30.6l-0.52-0.556c-0.916-0.978-1.818-1.924-2.689-2.844l-0.058-0.062c-6.276-6.6-11.227-11.809-11.227-17.142 0-5.507 4-8.391 7.929-8.391 3.067 0 5.502 2.991 6.564 4.556 1.067-1.56 3.502-4.542 6.573-4.542 3.938 0 7.92 2.876 7.92 8.378 0 5.333-4.956 10.542-11.227 17.142l-0.156 0.173c-0.844 0.889-1.711 1.778-2.591 2.738zM9.436 2.493c-3.498 0-7.040 2.578-7.040 7.502s4.844 10.071 10.973 16.524l0.062 0.067c0.836 0.889 1.693 1.778 2.564 2.711q1.253-1.333 2.462-2.6l0.16-0.169c6.138-6.458 10.982-11.556 10.982-16.529s-3.556-7.489-7.031-7.489c-3.067 0-5.516 3.6-6.196 4.702l-0.373 0.613-0.378-0.618c-0.68-1.102-3.133-4.716-6.187-4.716z"
  }));
}, "WishlistFullSvg");
var WishlistFullIcon = /* @__PURE__ */ __name(function WishlistFullIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: WishlistFullSvg
  }, props));
}, "WishlistFullIcon");
export {
  WishlistFullIcon
};
